import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import { MoralisProvider } from "react-moralis";

ReactDOM.render( 
     <CookiesProvider>
        <MoralisProvider appId={process.env.REACT_APP_MORALIS_APP_ID} serverUrl={process.env.REACT_APP_MORALIS_SERVER_URL}>
                <App />
            </MoralisProvider>
    </CookiesProvider> 

    , document.getElementById('root'));


// TODO:

// GAT Site
    // mobile horizontal to portrait resize bug
    // fix sizes to adjust for white bar gone

// Mint Dashboard
    // fix dashboard using mesh ui library -> https://github.com/felixmariotto/three-mesh-ui
    // fix resizing issue

// Comicverse Dashboard
    // hanburger to choose volume
    // fix resizing issue
    // click to view nft bigger

